export const DIVISIONS_BD = [
  'Barishal', 'Chattogram', 'Dhaka', 'Khulna',
  'Mymensingh', 'Rajshahi', 'Rangpur', 'Sylhet',
];
export const FUEL_TYPES = ['OCTANE', 'PETROL', 'DIESEL', 'KEROSENE', 'CNG', 'LPG'] as const;
export const PAYMENT_METHODS = ['CASH', 'BKASH', 'NAGAD', 'ROCKET', 'CARD', 'CREDIT', 'CORPORATE'] as const;
export const SUBSCRIPTION_PLANS = {
  STARTER: { name: 'Starter', maxPumps: 4, maxUsers: 5, priceBDT: 2000 },
  PROFESSIONAL: { name: 'Professional', maxPumps: 12, maxUsers: 20, priceBDT: 5000 },
  ENTERPRISE: { name: 'Enterprise', maxPumps: 50, maxUsers: 100, priceBDT: 15000 },
} as const;
